import { Box, Container } from "@mui/material";
import React from "react";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";
import { motion } from "framer-motion";
function Frequently() {
  let staticText = translation[language];

  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={{}}>
            <CustomText
              desc={staticText.frequentlyQue}
              fontFamily="Epilogue"
              colorvalue={Colors.andaihubTxt}
              style={{ ...styles.coreFeatureTxt,
                fontSize: {
                  xs: '20px',    // for extra-small devices
                  sm: '28px',    // for small devices
                  md: '32px',    // for medium devices
                  lg: '36px',    // for large devices
                  xl: '40px'     // for extra-large devices
                }
               }}
              title3
              fontWeight={400}
            />
          </Box>

          <Box
            sx={{
              width: "100%",
              justifyContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            {staticText.faqArray.map((item, index) => (
              <Box key={index} sx={styles.coreFeatureSubBox}>
                <Box sx={styles.coreSecondBox}>
                  <CustomText
                    desc={item.question}
                    fontFamily="Epilogue"
                    colorvalue={Colors.coreFeatureHeadText}
                    style={{ ...styles.headText }}
                    h4
                    fontWeight={400}
                  />
                  <CustomText
                    desc={item.answer}
                    fontFamily="Inter"
                    colorvalue={Colors.textColor}
                    style={{ ...styles.descText, marginTop: 1.3 }}
                    h5
                    fontWeight={400}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}
const styles = {
  headText: {
    lineHeight: 1.4,
    fontStyle: "initial",
  },
  descText: {
    lineHeight: 1.5,
    fontStyle: "initial",
  },
  coreFeatureSubBox: {
    width: {
      xs: '100%',    // full width for mobile
      sm: '100%',    // full width for small tablets
      md: '80%',     // 80% width for tablets
      lg: '60%',     // 60% width for laptops
      xl: '50%'      // 50% width for large screens
    },
    marginBottom: 1.3,
    objectFit: "cover",
    borderRadius: 4,
    display: "flex",
    backgroundColor: Colors.white,
    borderWidth: 0,
    pl: 4,
    pr: 4,
    pt: 3.5,
    pb: 3.5,
  },
  coreSecondBox: {
    display: "grid",
    flexDirection: "column",
  },
  coreFeatureBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    width: "100%",
  },
  container: {
    paddingTop: {
      xs: 2,    // 48px
      sm: 8,    // 64px
      md: 9,    // 72px
      lg: 10,   // 80px
      xl: 11,   // 88px
    },
    paddingBottom: {
      xs: 8,    // 64px
      sm: 10,   // 80px
      md: 11,   // 88px
      lg: 12,   // 96px
      xl: 13,   // 104px
    },
    backgroundColor: Colors.themeColor,
  },

  containerStyle: {
    backgroundColor: Colors.themeColor,
  },
  coreFeatureTxt: {
    lineHeight: 1,
    fontStyle: "initial",
    textTransform: "none",
    textAlign: "center",
    paddingBottom: {
      xs: 3,    // 24px
      sm: 4,    // 32px
      md: 5,    // 40px
      lg: 6,    // 48px
      xl: 7,    // 56px
    },
    paddingTop: {
      xs: 4,    // 32px
      sm: 5,    // 40px
      md: 6,    // 48px
      lg: 8,    // 64px
      xl: 9,    // 72px
    },
  },
};

export default Frequently;
